import { render } from "./IconArrowLeft40px.vue?vue&type=template&id=e5ac03c6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__